<template>
	<div class="content">
		<container v-if="!loaded"><loading /></container>
        <div class="md-layout" v-if="loaded">
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"
				style="margin-bottom:15px;display: flex;align-items: center;">
				<h4 class="application-title" style="font-weight: bold;">{{translate(locale.edit_unit)}}</h4>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"
				style="margin-bottom:15px; display: flex;">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<form-input v-model="unit.name" :label="locale.unit_name" />
						</div>
					</div>
				</container>
			</div>
			<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100"
				style="margin-bottom:15px">
				<container>
					<div class="md-layout">
						<div class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100">
							<div class="error-text">
								<p v-for="e in errors">* {{translate(e)}}</p>
							</div>
						</div>
						<div
							class="md-layout-item md-xsmall-size-100 md-small-size-100 md-medium-size-100 md-size-100 text-right">
							<md-button class="md-raised md-primary"
								@click="updateUnit()">{{translate(locale.edit_unit)}}</md-button>
						</div>
					</div>
				</container>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		data() {
			return {
				loaded: false,
				unit: { name: "" },
				errors: []
			}
		},
		created() {
			this.getUnit();
		},
		methods: {
			getUnit() {
				this.$http.get(this.config.api + "/user/unit/get/" + this.$route.params.hash).then(data => {
					this.unit.name = data.body.data.name;
					this.loaded = true;
				});
			},
			updateUnit() {

				if (!this.checkValidation()) {
					return;
				}

				this.$http.post(this.config.api + "/user/unit/update", {
					hash: this.$route.params.hash,
					unit: this.unit
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "You have updated an unit successfully.||អ្នកបានកែប្រែអង្គភាពដោយជោគជ័យ។",
							icon: 'check_circle',
							type: 'success'
						});

						this.$router.push("/units");
					}
				})
			},
			checkValidation() {
				this.errors = [];

				if (String(this.unit.name).length <= 0) this.errors.push("Please fill in Unit Name.||សូមបំពេញ ឈ្មោះអង្គភាព។");

				if (this.errors.length == 0) return true;
				else return false;
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/pages/Units/Edit.vue